
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { BriefingProgress } from "@/model/BriefingProgress";

    @Component({})
    export default class BriefingProgressBar extends Vue {

        @Prop({ required: true })
        progress!: BriefingProgress;

        get percentText(): string {
            return `${Math.round(this.progress.percent)}%`;
        }

    }
